module.exports = __webpack_public_path__ + "img/u25.5058c52a.png";